import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'docsGoogle'
})
export class DocsGooglePipe implements PipeTransform {

  transform(value: string): string {
    return `https://docs.google.com/viewerng/viewer?url=${value}&embedded=true`;
  }

}
